import { render } from "./VerifyData.vue?vue&type=template&id=728baf1e"
import script from "./VerifyData.vue?vue&type=script&lang=js"
export * from "./VerifyData.vue?vue&type=script&lang=js"

import "./VerifyData.vue?vue&type=style&index=0&id=728baf1e&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__